<template>
	<i class="Thumb">
		<img :src="path" />
	</i>
</template>

<script>
	import { mapState } from 'vuex';
	export default {
		props: ['thumb'],
		computed: {
			...mapState(['bot']),
			path() {
				let logo = process.env.VUE_APP_VERT && process.env.VUE_APP_VERT == 'anybot' ? 'anybot.jpg' : 'anyhook.jpeg';
				return this.thumb || this.bot.widget_thumb || `${process.env.VUE_APP_ROOT_PATH + (process.env.VUE_APP_ROOT_PATH.endsWith('/') ? '' : '/')}images/${logo}`;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.Thumb {
		background-color: white;
		display: block;
		width: 4rem;
		height: 4rem;
		border-radius: 3rem;
		position: relative;
		overflow: hidden;
		margin-right: 1rem;
		border: solid 1px rgba(0, 0, 0, 0.1);

		img {
			width: 100%;
			height: 100%;
		}
	}
</style>
